import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'trial.content.title',
		defaultMessage: 'Content Made with Families in Mind',
		description: 'Heading for content slider',
	},
});
